export default __webpack_public_path__ + "static/media/mu.fd1c498d.svg";